import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import { trackPageView } from 'utils/analytics';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes], { basename: import.meta.env.VITE_APP_BASE_NAME });

let lastTrackedPath = '';
router.subscribe((state) => {
  const nextPath = `${state.location.pathname}${state.location.search}`;
  if (state.navigation.state === 'idle' && nextPath !== lastTrackedPath) {
    lastTrackedPath = nextPath;
    trackPageView(state.location);
  }
});

export default router;
